import { defineComponent, ref } from 'vue';
import ProvinceFilterComponent from '@/components/provinceFilter/ProvinceFilter.vue';
import EmergencyTableComponent from '@/components/emergencyTable/EmergencyTable.vue';
import EmergencyFormComponent from '@/components/emergencyTable/emergencyForm/EmergencyForm.vue';

export default defineComponent({
  name: 'ProblemPage',
  components: {
    ProvinceFilterComponent,
    EmergencyTableComponent,
    EmergencyFormComponent,
  },
  setup: () => {
    const fiscalYearId = ref<number | null>();
    const provinceId = ref<number | null>();
    const selectedEmergencyId = ref<number | null>();
    const emergencyForm = ref<InstanceType<typeof EmergencyFormComponent>>();

    const filterChange = (filter: { fiscalYearId: number; provinceId: number }) => {
      fiscalYearId.value = filter.fiscalYearId;
      provinceId.value = filter.provinceId;
    };

    const createClick = () => {
      emergencyForm.value?.show();
    };

    return {
      emergencyForm,
      fiscalYearId,
      provinceId,
      selectedEmergencyId,
      filterChange,
      createClick,
    };
  }
});
